import { CheckboxEmptyIcon, CheckboxSelectedIcon } from "../icons";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
import { jsxs as _jsxs } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
export var CheckboxInput = function CheckboxInput(_ref) {
  var id = _ref.id,
    labelId = _ref.labelId,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    checked = _ref.checked,
    className = _ref.className,
    size = _ref.size;
  var handleChange = function handleChange() {
    onChange();
  };
  var iconColor = disabled ? "dt_taro30" : "dt_taro50";
  return _jsx("div", {
    // adding classname so devs can style input wrapper with sx
    className: className,
    children: _jsxs("div", {
      sx: inputRadioContainerStyles,
      children: [_jsx("input", {
        id: id,
        type: "checkbox",
        disabled: disabled,
        onChange: handleChange,
        checked: checked,
        sx: invisibleInputStyles,
        "aria-labelledby": labelId
      }), _jsx("div", {
        children: checked ? _jsx(CheckboxSelectedIcon, {
          "aria-hidden": true,
          size: size,
          color: iconColor
        }) : _jsx(CheckboxEmptyIcon, {
          "aria-hidden": true,
          size: size,
          color: iconColor
        })
      })]
    })
  });
};
var inputRadioContainerStyles = {
  position: "relative",
  flex: "none",
  lineHeight: 0,
  "[type='checkbox']:focus + div": {
    outline: "2px solid",
    outlineColor: "dt_blueberry60",
    outlineOffset: "1px"
  },
  "[type='checkbox']:not(:focus-visible) + div": {
    outline: "none" // allowing only keyboard focus
  }
};

var invisibleInputStyles = {
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  zIndex: 100,
  cursor: "pointer",
  ":disabled": {
    cursor: "not-allowed"
  }
};